module.exports = __webpack_public_path__ + "img/Weapon_206.a2278703.png";